export interface ComboboxOption {
  id: string | number
  value: string
  highlights?: string[]
}

export interface ComboboxOptionGroup {
  name: string
  options: Array<ComboboxOption>
}

export type ComboboxOptions = Array<ComboboxOption | ComboboxOptionGroup>

export const isOptionGuard = (item: any): item is ComboboxOption => {
  return (item as ComboboxOption).value !== undefined
}

export const isOptionGroupGuard = (
  option: ComboboxOption | ComboboxOptionGroup,
): option is ComboboxOptionGroup => {
  return (option as ComboboxOptionGroup).name !== undefined
}
